import { OptionProps } from 'src/components/ButtonDropdown';

export const SEARCH_GROUPS: OptionProps[] = [
  { label: 'By Episode', value: 'episode' },
  { label: 'By Show', value: 'show' },
];

export const CAMPAIGN_ROWS_ALIGNMENT_OPTIONS: OptionProps[] = [
  { label: 'All alignment', value: '' },
  { label: 'Aligned', value: 'aligned' },
  { label: 'Misaligned', value: 'misaligned' },
  { label: 'Matched', value: 'matched' },
  { label: 'Not matched', value: 'not matched' },
];

export const SHOW_ONLY_SEARCH_GROUPS: OptionProps[] = [
  { label: 'By Show', value: 'show' },
];
